import styled from 'styled-components'
// constants
import { ENTITIES } from 'constants/entities'
// theme
import { colors } from 'themes/index'
import { sidebarIconCSS } from 'themes/views/layouts'
// static
import BusinessUnitsIconOrigin from 'src/icons/hierarchy.svg'
import BusinessProcessesIconOrigin from 'src/icons/process.svg'
import BusinessActivityIconOrigin from 'src/icons/activity.svg'
// utils
import { ellipsis } from 'polished'

export const ChildrenWrapper = styled.div<{ entity: keyof typeof ENTITIES }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 74%;

  ${({ entity }) => entity === ENTITIES.BUSINESS_UNIT && 'max-width: 76.5%'};
  ${({ entity }) => (entity === ENTITIES.POSITION || entity === ENTITIES.USER) && 'max-width: 85.5%'};
`

export const EntityText = styled.span`
  font-size: 12px;
  font-style: italic;
  position: absolute;
  right: 16px;
  text-transform: capitalize;
  color: ${colors.gray300};
`

export const LabelWrapper = styled.div`
  ${ellipsis('100%')};
`

export const IconWrapper = styled.div`
  color: ${colors.gray900};
  margin-right: 10px;
`

export const BusinessUnitsIcon = styled(BusinessUnitsIconOrigin)`
  ${sidebarIconCSS}
`

export const BusinessProcessesIcon = styled(BusinessProcessesIconOrigin)`
  ${sidebarIconCSS}
`

export const BusinessActivityIcon = styled(BusinessActivityIconOrigin)`
  ${sidebarIconCSS}
`
